import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, Chip, Box } from '@mui/material';
import AvatarIcon from '../../assets/imgIcons/avatar.png';
import Avatar from '../common/Avatar';

const EmailField = ({ setSelectedCcEmails, clear, error, helperText, size }) => {
    const [searchInput, setSearchInput] = useState('');
    const [ccList, setCcList] = useState([]);
    const [showSelectedOnly, setShowSelectedOnly] = useState(false);

    const handleInputChange = (_, value) => {
        setSearchInput(value);
    };

    // Keep ccList and parent-selected emails in sync directly on change
    const handleCcChange = (_, values) => {
        setCcList(values);
        setSelectedCcEmails(values);
    };

    // When parent asks to clear, reset local + parent state once
    useEffect(() => {
        if (clear) {
            setSelectedCcEmails([]);
            setCcList([]);
            setSearchInput("");
        }
        // we intentionally don't depend on setSelectedCcEmails (stable from React)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clear]);

    const handleShowSelectedOnly = () => {
        setShowSelectedOnly(!showSelectedOnly);
    };

    // Filter out selected options from options array
    const optionsWithoutSelected = [searchInput, ...ccList].filter(option => !ccList.includes(option));

    const isValidEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const showOptionsTray = isValidEmail(searchInput) && !showSelectedOnly;

    return (
        <Box>
            <Autocomplete
                multiple
                freeSolo
                id="tags-filled"
                options={showOptionsTray ? optionsWithoutSelected : []}
                value={ccList}
                inputValue={searchInput}
                onInputChange={handleInputChange}
                onChange={handleCcChange}
                size={size}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        return (
                            <Chip
                                key={option}
                                label={option}
                                onDelete={() => {
                                    const filteredList = ccList.filter((email) => email !== option);
                                    setCcList(filteredList);
                                }}
                                avatar={
                                    <Avatar
                                        src={AvatarIcon}
                                        alt="avatarImg"
                                        size="tiny"
                                        shape="round"
                                        border={false}
                                        borderColor=""
                                        bgColor=""
                                        textColor="#fff"
                                        initials=""
                                        name=""
                                        className="mr-2"
                                    />
                                }
                                {...tagProps}
                            />
                        );
                    })
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Fyi To"
                        variant="outlined"
                    />
                )}
                renderOption={(props, option, { selected }) => {
                    // Extract key from props to prevent spreading it
                    const { key, ...restProps } = props;
                    return (
                        <Box
                            component="li"
                            sx={{ '& > img': { mr: 1, flexShrink: 0 } }}
                            key={key} // Pass key explicitly here
                            {...restProps} // Spread remaining props here
                        >
                            <Avatar
                                src={AvatarIcon}
                                alt="avatarImg"
                                size="tiny"
                                shape="round"
                                border={false}
                                borderColor=""
                                bgColor=""
                                textColor="#fff"
                                initials=""
                                name=""
                                className="mr-2"
                            />
                            {option}
                        </Box>
                    );
                }}
            />
        </Box>
    );
};

export default EmailField;
